// client/buildify/preview-schema.ts
import { isNodeSelection } from "@adornis/html-based-buildify/client/util.js";
import { html } from "lit/html.js";
var PREVIEW_KEY = "toggle-preview";
var preview = (onClick) => ({
  node: {
    name: PREVIEW_KEY,
    schema: {
      attrs: {
        data: { default: {} }
      }
    }
  },
  menuItems: [
    {
      label: "Preview",
      icon: "visibility",
      run: (view) => {
        onClick();
      },
      shouldVisualize: (view) => !isNodeSelection(view.state.selection)
    }
  ],
  editor: ({ content, contentController, controllerBaseKeyPath, host }) => {
    return html``;
  }
});
export {
  preview
};
